import terms from "./terms.md?raw";
import { PageHeader } from "../ui";

// ponytail: minimal markdown subset (h1/h2/p/ul, **bold**, auto-linked URLs/emails).
// Swap for a real renderer if terms.md ever needs more than that.
function inline(text: string): React.ReactNode[] {
  const parts = text.split(/(\*\*[^*]+\*\*|https?:\/\/\S+?(?=[\s)]|$)|[\w.+-]+@[\w-]+\.[\w.]*\w)/g);
  return parts.map((p, i) => {
    if (p.startsWith("**")) return <strong key={i} className="font-semibold">{p.slice(2, -2)}</strong>;
    if (p.startsWith("http")) return <a key={i} href={p} target="_blank" rel="noopener noreferrer" className="text-accent hover:underline break-all">{p}</a>;
    if (/^[\w.+-]+@/.test(p)) return <a key={i} href={`mailto:${p}`} className="text-accent hover:underline">{p}</a>;
    return p;
  });
}

function render(md: string): { title: string; date: string; body: React.ReactNode[] } {
  let title = "";
  let date = "";
  const body: React.ReactNode[] = [];
  let list: string[] = [];
  const flush = () => {
    if (list.length) {
      body.push(
        <ul key={body.length} className="list-disc pl-5 mb-3 space-y-1">
          {list.map((l, i) => <li key={i}>{inline(l)}</li>)}
        </ul>,
      );
      list = [];
    }
  };
  for (const line of md.split("\n")) {
    if (line.startsWith("- ")) { list.push(line.slice(2)); continue; }
    flush();
    if (!line.trim()) continue;
    if (line.startsWith("# ")) title = line.slice(2);
    else if (line.startsWith("Effective date:")) date = line;
    else if (line.startsWith("## ")) body.push(<h3 key={body.length} className="text-base font-semibold text-main mt-6 mb-2 first:mt-0">{line.slice(3)}</h3>);
    else body.push(<p key={body.length} className="mb-3">{inline(line)}</p>);
  }
  flush();
  return { title, date, body };
}

export function Terms() {
  const { title, date, body } = render(terms);
  return (
    <section className="max-w-[760px]">
      <PageHeader title={title} description={date} />
      <div className="p-8 max-sm:p-4 rounded-lg bg-card border border-border text-[15px] text-main leading-relaxed">
        {body}
      </div>
    </section>
  );
}
